// extracted by mini-css-extract-plugin
export default {"panel":"panel_panel__i1v0A","empty":"panel_empty__6YYf9"};